import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "footerbadges"
}
const _hoisted_4 = {
  rowspan: "2",
  width: "300"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "hidemobile" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "hidemobile" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "helperlinks" }
const _hoisted_11 = { class: "helperlinks" }
const _hoisted_12 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "finalfooter"
}
const _hoisted_13 = { class: "creditcards" }
const _hoisted_14 = ["src"]

import ModalNames from "@/utils/ModalNames";
import { ref, computed, ComputedRef } from "vue";
import { ModalsArr } from "@/utils/ModalsArr";
import ModalLinks from "@/views/partials/ModalLinks.vue";
import { getCurrentYear } from "@/utils/Utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeFooter',
  setup(__props) {

const footerModals = ModalsArr;

//TODO checks
const partnershipsModal = ref<InstanceType<
  typeof ModalNames.PARTNERSHIPS_MODAL
> | null>(null);
const contactNssiModal = ref<InstanceType<
  typeof ModalNames.CONTACT_MODAL
> | null>(null);

// const element = document.body.getElementsByClassName("modal hide");
// console.log(element);
const assurantBookletPath: ComputedRef<string> = computed(() => {
  return window.location.href + "assets/assurantpolicybooklet.pdf";
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("img", {
                loading: "lazy",
                src: require('@/assets/images/footer-logo.png'),
                width: "238",
                alt: "Footer NSSI Logo"
              }, null, 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  loading: "lazy",
                  src: require('@/assets/images/footer-icon3.svg'),
                  class: "footericonfloat",
                  width: "59",
                  height: "50",
                  alt: "Icon"
                }, null, 8, _hoisted_7),
                _cache[0] || (_cache[0] = _createTextVNode("Excellent Customer Service ", -1))
              ])
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  loading: "lazy",
                  src: require('@/assets/images/footer-icon2.svg'),
                  class: "footericonfloat",
                  width: "59",
                  height: "50",
                  alt: "Icon"
                }, null, 8, _hoisted_9),
                _cache[1] || (_cache[1] = _createTextVNode("Unsatisfied? Cancel Anytime. ", -1))
              ])
            ])
          ])
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("p", _hoisted_10, [
        _createElementVNode("span", null, [
          _createVNode(_component_router_link, { to: { name: 'quote' } }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Get a Quote", -1)
            ]))]),
            _: 1
          })
        ]),
        _createVNode(ModalLinks, {
          modals: _unref(footerModals),
          style: {"display":"inline !important","padding-left":"20px"},
          title: "footer"
        }, null, 8, ["modals"]),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, " National Student Services Inc. has partnered with Assurant to offer Renters Insurance to college students. NSSI is the administrator of the accidental damage personal property coverage of this offer. Both policies are backed by A.M. Best \"A\" Rating underwriters. We are not responsible for Assurant coverage selections, policies issued, claims, the content or operation of others' websites, or how others handle or use your information. Information you provide to others is subject to their privacy policies and website terms of use. The producer will receive compensation from the insurance company for the sale of this insurance. ", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", null, " National Student Services, Inc. has been family-owned and operated since 1971. Based in Stillwater, Oklahoma, NSSI is a leader in providing college students with personal property accidental damage insurance. You can expect reliable insurance paired with exceptional customer service. ", -1)),
      _createElementVNode("p", _hoisted_11, [
        _cache[5] || (_cache[5] = _createElementVNode("a", {
          href: "https://www.nssi.com/terms-of-use",
          target: "_blank"
        }, "Terms of Use", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("a", {
          href: "https://www.nssi.com/privacy-policy",
          target: "_blank"
        }, "Privacy Policy", -1)),
        _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Assurant Legal ", -1)
          ]))]),
          _: 1
        }),
        _cache[7] || (_cache[7] = _createElementVNode("a", {
          href: "https://www.nssi.com/unsubscribe",
          target: "_blank"
        }, "Unsubscribe", -1))
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, " © " + _toDisplayString(_unref(getCurrentYear)) + " National Student Services, Inc. All Rights Reserved. ", 1),
            _createElementVNode("td", _hoisted_13, [
              _createElementVNode("img", {
                loading: "lazy",
                style: {"max-width":"581px","width":"100% !important","height":"auto !important"},
                src: require('@/assets/images/creditcards.png'),
                alt: "Credit Cards Accepted Payment Methods BBB A+ PCI"
              }, null, 8, _hoisted_14)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})